{
  "R": [192, 224, 255],
  "G": [1, 128, 255],
  "B": [0, 0, 0],
  "A": [0, 64, 128],
  "I": [0, 128, 255]
}
